import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase'; // Ensure this path is correct for your Supabase client

export interface RentalBurdenRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  rent_burden_share: number;
  // Add any other fields you expect from the 'acs_bps_metrics_rental_affordability' view
}

export function useRentalBurdenData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<RentalBurdenRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false); // Not loading if no params
      setData([]); // Clear data if no params
      setError(null); // Clear any previous errors
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_rental_affordability') // Name of your view
      .select('*')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: true })
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching rental burden data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Rent Burden Share: ${latest.rent_burden_share?.toFixed(2)}%`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 